/**
 * 分期商城卡片相关类型定义
 */

import { ContractContentTypeEnum } from '@/api/rights/types';

/** 整体转换后的映射关系 */
export enum InstallMallCreditStatusEnum {
  /** 初始化，可授信，待授信 */
  WAIT_CREDIT = 1,
  /** 授信提交中 */
  CREDIT_PROCESSING = 2,
  /** 授信成功 */
  CREDIT_SUCCESS = 3,
  /** 授信失败 */
  CREDIT_FAIL = 4,
}

export type ProductItemType = {
  productId: string;
  productName: string;
  productIcon: string;
};

export interface ContractItem {
  /** 合同名称 */
  name: string;
  /** 合同详情地址 */
  contentUrl: string;
  /** 内容类型（1-PDF，2-其他） */
  contentType: number;
}

export interface ContractInfo {
  /** 聚合合同名称 */
  contractTitle: string;
  /** 合同列表信息 */
  contractList: ContractItem[];
}

export interface CreditMallApplyResponse {
  /** 申请流水号 */
  creditApplyNo?: string;
  creditTaskId?: string;
  /** 申请成功后跳转地址 */
  successJumpUrl?: string;
}

export interface QueryCreditApplyStatusResponse {
  /** 授信状态归笼 */
  creditFrontStatus: InstallMallCreditStatusEnum;
  /** 授信金额 */
  creditAmount?: string;
  /** 跳转地址 */
  jumpUrl?: string;
}
